import Phaser from "phaser";

export default class Arrow {
    public Damage: number;
    public IsCritical: boolean;
    public IsExploding: boolean = false;
    public ExplosionRadius: number = 0;
    public ExplosionDamageMultiplier: number = 0;
    public IsPiercing: boolean = false;
    private mAlreadyHit: Set<object> = new Set();

    public HasAlreadyHit(target: object): boolean {
        return this.mAlreadyHit.has(target);
    }

    public MarkHit(target: object): void {
        this.mAlreadyHit.add(target);
    }

    private mAngle;
    private mCurrentX;
    private mCurrentY;
    private mOldX;
    private mOldY;
    private mGForce = 0.3;
    private mSprite;

    constructor(sprite) {
        this.Damage = 20; //Just something default
        this.mSprite = sprite;
    }

    public Init(angle: number, gForce: number = 0.3) {
        this.mSprite.angle = angle;
        this.mCurrentX = this.mOldX = this.mSprite.x;
        this.mCurrentY = this.mOldY = this.mSprite.y;
        this.mGForce = gForce;
    }

    public Update() {
        this.mCurrentX = this.mSprite.body.position.x;
        this.mCurrentY = this.mSprite.body.position.y;
        this.mCurrentY += this.mGForce;
        if (this.mCurrentX === this.mOldX) {
            return;
            // Do not recalculate since position is same
        }
        this.mAngle = Math.atan2(this.mCurrentX - this.mOldX, -(this.mCurrentY - this.mOldY)) * (180 / Math.PI);

        this.mSprite.body.position.x = this.mCurrentX;
        this.mSprite.body.position.y = this.mCurrentY;
        this.mSprite.angle = this.mAngle - 90;
        this.mSprite.body.angle = this.mAngle - 90;

        this.mOldX = this.mCurrentX;
        this.mOldY = this.mCurrentY;
    }

    // TODO: Add power
    public ShootArrow(mouseX: number, mouseY: number, bowX: number, bowY: number, power: number) {
        // Previous:
        // this.mSprite.body.velocity.x = (mouseX - bowX) * (power);
        // this.mSprite.body.velocity.y = (((mouseY - bowY)) * (power));

        // Calculate the direction vector
        const dirX = mouseX - bowX;
        const dirY = mouseY - bowY;

        // Scale vertical velocity for upward shots
        const upwardBoostFactor = 1.5; // Adjust as needed for stronger upward shots
        const adjustedDirY = dirY * (dirY < 0 ? upwardBoostFactor : 1); // Boost only for upward shots

        // Apply power proportionally
        this.mSprite.body.velocity.x = dirX * power;
        this.mSprite.body.velocity.y = adjustedDirY * power;
    }


    public IsMoving() {
        return this.mSprite.body.velocity.x != 0 && this.mSprite.body.velocity.y != 0;
    }

    destroy() {
        return this.mSprite.destroy();
    }


    CheckCollision(scene: Phaser.Scene, entity: Phaser.Types.Physics.Arcade.ArcadeColliderType) {
        return scene.physics.overlap(this.mSprite, entity, this.OnCollision, undefined, this);
    }

    private OnCollision(bullet, enemy) {
    }

}
